exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".step-template-copy-question-to .el-select-multiple-tag-ellipsis .el-tag .el-select__tags-text{max-width:280px;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:top}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/CopyQuestionTo.vue"],"names":[],"mappings":"AACA,+FAA+F,gBAAgB,qBAAqB,mBAAmB,gBAAgB,uBAAuB,kBAAkB,CAC/M","file":"CopyQuestionTo.vue","sourcesContent":["\n.step-template-copy-question-to .el-select-multiple-tag-ellipsis .el-tag .el-select__tags-text{max-width:280px;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:top\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04f847e4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/step-template/components/CopyQuestionTo.vue
// module id = 3664
// module chunks = 6